import React from 'react';
import { IconProps } from './icons.models';

const AddIcon: React.FC<IconProps> = ({
    width = 17,
    height = 17,
    fillColor,
    className,
    onClick,
}) => {
    return (
        <svg width={width} height={height} className={className} onClick={onClick} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.51953 8.5H13.3772" stroke={fillColor || '#3EAE54'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8.44922 3.54102V13.4577" stroke={fillColor || '#3EAE54'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default AddIcon;

